import script from "./EditModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditModule.vue?vue&type=script&setup=true&lang=ts"

import "./EditModule.vue?vue&type=style&index=0&id=1f802ffd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f802ffd"]])

export default __exports__